const settings = {
  platform: null,
  whatsapp: null
}

export default settings
